/* eslint eqeqeq: "off" */

// ---------------------------------
// LOCAL STORAGE
// ---------------------------------
const localStorage = (function () {
  const uid = new Date()
  let localStorage
  let result
  try {
    // prettier-ignore
    (localStorage = window.localStorage).setItem(uid, uid)
    result = localStorage.getItem(uid) == uid
    localStorage.removeItem(uid)
    return result && localStorage
  } catch (exception) {
    console.error("LocalStorage inaccessible")
  }
})()

/**
 * Set key-value to localstorage
 * @param {string} key the key of the LS record
 * @param {string} value the value of the LS record
 * @returns {boolean}
 */
export const setLs = (key, value) => {
  if (localStorage) {
    if (value) {
      localStorage.setItem(key, value)
    } else {
      localStorage.removeItem(key)
    }
    return true
  } else {
    return false
  }
}

/**
 * Set key-value to localstorage
 * @param {string} key the key of the LS record
 * @param {object} value the value of the LS record
 * @returns {boolean}
 */
export const setLsObj = (key, value) => {
  if (localStorage) {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.removeItem(key)
    }
    return true
  } else {
    return false
  }
}

/**
 * Get key from localstorage
 * @param {string} key the key of the LS record
 * @returns {string|null}
 */
export const getLs = (key, fallback = null) => {
  if (localStorage) {
    return localStorage.getItem(key) ?? fallback
  } else {
    return null
  }
}

/**
 * Get key from localstorage
 * @param {string} key the key of the LS record
 * @param {mixed} fallback the default value to return if key is null
 * @param {boolean} initialize
 * @returns {object|null}
 */
export const getLsObj = (key, fallback = null, initialize = false) => {
  if (localStorage) {
    const value = JSON.parse(localStorage.getItem(key))
    if (!value && initialize) {
      setLsObj(key, fallback)
    }
    return value ?? fallback
  } else {
    return null
  }
}
/**
 * Remove key from localstorage
 * @param {string} key the key of the LS record
 * @returns {void}
 */
export const clearLS = (key) => {
  if (localStorage) {
    localStorage.removeItem(key)
  }
}

// ---------------------------------
// SESSION STORAGE
// ---------------------------------
const sessionStorage = (function () {
  const uid = new Date()
  let sessionStorage
  let result
  try {
    // prettier-ignore
    (sessionStorage = window.sessionStorage).setItem(uid, uid)
    result = sessionStorage.getItem(uid) == uid
    sessionStorage.removeItem(uid)
    return result && sessionStorage
  } catch (exception) {
    console.error("SessionStorage inaccessible")
  }
})()

/**
 * Set key-value to sessionStorage
 * @param {string} key the key of the LS record
 * @param {string} value the value of the LS record
 * @returns {boolean}
 */
export const setSs = (key, value) => {
  if (sessionStorage) {
    if (value) {
      sessionStorage.setItem(key, value)
    } else {
      sessionStorage.removeItem(key)
    }
    return true
  } else {
    return false
  }
}

/**
 * Set key-value to sessionStorage
 * @param {string} key the key of the LS record
 * @param {object} value the value of the LS record
 * @returns {boolean}
 */
export const setSsObj = (key, value) => {
  if (sessionStorage) {
    if (value) {
      sessionStorage.setItem(key, JSON.stringify(value))
    } else {
      sessionStorage.removeItem(key)
    }
    return true
  } else {
    return false
  }
}

/**
 * Get key from sessionStorage
 * @param {string} key the key of the LS record
 * @returns {string|null}
 */
export const getSs = (key, fallback = null) => {
  if (sessionStorage) {
    return sessionStorage.getItem(key) ?? fallback
  } else {
    return null
  }
}

/**
 * Get key from sessionStorage
 * @param {string} key the key of the LS record
 * @returns {object|null}
 */
export const getSsObj = (key, fallback = null) => {
  if (sessionStorage) {
    return JSON.parse(sessionStorage.getItem(key)) ?? fallback
  } else {
    return null
  }
}

/**
 * Remove key from localstorage
 * @param {string} key the key of the LS record
 * @returns {void}
 */
export const clearSs = (key) => {
  if (sessionStorage) {
    sessionStorage.removeItem(key)
  }
}

export const updateSsObject = (key, value) => {
  const existing = getSsObj(key, {})
  const updated = { ...existing, ...value }
  setSsObj(key, updated)
}
